<template>
    <div :class="'accordion__title' + openClass" @click="toggleCollapse" style="cursor: pointer;">
        {{ title }}
        <div v-if="(title.toLowerCase().includes('auto') && index != 0) || title.toLowerCase().includes('hij@')"
            class="accordion__title-icon_delete">
            <img :src="iconUrl" alt="">
        </div>
        <input :id="id" class="accordion__checkbox" v-model="open" type="checkbox" />
        <label :for="id" @click="toggleCollapse" class="accordion__title-icon">
            <img src="/img/icons/accarr.svg" @click="toggleCollapse" alt="">
        </label>
    </div>
</template>
<script>
export default {
    props: ["open", "id", "title", "index","iconUrl"],
    name: "AccordionTitle",
    methods: {
        toggleCollapse(event) {
            if (event.target.localName == "img") {
                if (event.target.attributes.src.nodeValue == "/img/icons/borrar-default.svg") {
                    this.$emit('delete')
                } else {
                    this.$emit("toggle");
                }
            } else {
                this.$emit("toggle");
            }
        },
    },
    computed: {
        openClass() {
            return this.open ? ' accordion__title--open' : '';
        }
    }
}
</script>
<style>
.accordion__title-icon_delete {
    -webkit-transition: all .2s;
    transition: all .2s;
    float: right;
    cursor: pointer;
    margin-left: 1.25rem;
}

.text-pop-delete {
    display: block;
    font-size: 1.4rem;
    text-align: justify;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    color: black
}
</style>